import { useMemo } from "react";
import Highcharts from "./customHighCharts";

const defaultHighchartsColors = Highcharts.defaultOptions.colors;

export const useChartOptions = customColors => {
  const colors = useMemo(() => {
    return customColors && customColors.length > 0
      ? customColors
      : defaultHighchartsColors;
  }, [customColors]);

  return {
    colors,
    exporting: {
      buttons: {
        contextButton: {
          enabled: false
        }
      },
      // Without the context button, the accessibility module treats the first custom
      // exporting button as the export menu button, causing incorrect accessibility
      // behavior and click interception.
      accessibility: {
        enabled: false
      }
    }
  };
};
